import { configureStore } from '@reduxjs/toolkit';
import EnquiryReducer from './enquiry';
import SlotReducer from './slot';
import CommonReducer from './common';
import feedbackReducer from './feedback';
import locationReducer from './location';
import vehicleReducer from './vehicle';
import categoryReducer from './category';
import leadReducer from './lead';
import regionReducer from './region';
import InspectionReducer from './inspectionBooking';
import TestimonialReducer from './testimonial';
import showroomReducer from './showroom';
import carDeliveryReducer from './carDelivery';
import YoutubeVideoReducer from './youtubeVideos';
import YoutubeShortsReducer from './youtubeShorts';
import SettingsReducer from './settings';

export default configureStore({
  reducer: {
    enquirys: EnquiryReducer,
    slot: SlotReducer,
    common: CommonReducer,
    feedback: feedbackReducer,
    location: locationReducer,
    vehicle: vehicleReducer,
    category: categoryReducer,
    lead: leadReducer,
    region: regionReducer,
    Inspection: InspectionReducer,
    Testimonial: TestimonialReducer,
    Showroom: showroomReducer,
    CarDelivery: carDeliveryReducer,
    YoutubeVideo: YoutubeVideoReducer,
    YoutubeShorts: YoutubeShortsReducer,
    settings: SettingsReducer,
  },
});
